export default function SvgVideo10() {
    return (
      <>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      fill="none"
      viewBox="0 0 48 48"
    >
      <g>
        <g>
          <path
            fill="#000"
            fillRule="evenodd"
            d="M11 12h14a1 1 0 011 1v3H7a3 3 0 00-3 3v16a3 3 0 003 3h24a3 3 0 003-3V21.945l8-3.428v16.965l-4.586-1.964a1 1 0 10-.788 1.839l4.587 1.964A1.999 1.999 0 0044 35.483V18.515a2 2 0 00-2.79-1.836L34 19.769V19a3 3 0 00-3-3h-3v-3a3 3 0 00-3-3H11a1 1 0 100 2zm-4 6h19v2a1 1 0 102 0v-2h3a1 1 0 011 1v16a1 1 0 01-1 1H7a1 1 0 01-1-1V19a1 1 0 011-1zm5 5a1 1 0 10-1.999-.001A1 1 0 0012 23zm-1 3a3 3 0 10.001-5.999A3 3 0 0011 26z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
    </svg>
   </>
  );
}